if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isOpen = false;
        this.swiper = null;
        this.mobileBreakpoint = 750;
      }

      hide() {
        // Restore the toggle button before super.hide() so removeTrapFocus can run,
        // then immediately blur it so its ::after overlay won't block swipe.
        if (this.openedBy) {
          this.openedBy.style.removeProperty("display");
          requestAnimationFrame(() => this.openedBy && this.openedBy.blur());
        }
        super.hide();
        this.isOpen = false;
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      show(opener) {
        super.show(opener);
        this.isOpen = true;
        // Hide the toggle button while the modal is open so it can't hold focus
        // and block swipe once the modal closes.
        if (opener) opener.style.display = "none";
        // Delay Swiper init to ensure modal is visible and has dimensions
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.showActiveMedia();
          });
        });
      }

      showActiveMedia() {
        if (!this.openedBy || !this.openedBy.getAttribute("data-media-id")) {
          this.initSwiper(0);
          /*if (window.innerWidth < this.mobileBreakpoint) {
            this.initSwiper(0);
          }*/
          return;
        }

        const mediaId = this.openedBy.getAttribute("data-media-id");
        const slides = this.querySelectorAll(".product-media-modal__slide");
        let initialSlide = 0;

        slides.forEach((slide, index) => {
          if (slide.getAttribute("data-media-id") === mediaId) {
            initialSlide = index;
          }
        });

        this.initSwiper(initialSlide);
        /* if (window.innerWidth < this.mobileBreakpoint) {
          this.initSwiper(initialSlide);
        } else {
          const activeSlide = this.querySelector(
            `[data-media-id="${mediaId}"]`
          );
          if (activeSlide) {
            activeSlide.scrollIntoView({ behavior: "instant" });
          }
        } */
      }

      initSwiper(initialSlide) {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        const swiperEl = this.querySelector(".product-media-modal__swiper");
        if (!swiperEl || typeof Swiper === "undefined") return;

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: initialSlide || 0,
          loop: false,
          allowTouchMove: true,
          grabCursor: true,
          pagination: {
            el: this.querySelector(".product-media-modal__pagination"),
            clickable: true,
          },
        });
      }
    }
  );
}
